import { createApp } from 'vue';
import App from './App.vue';
import store from './store';
import router from './router';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './assets/main.scss';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import FloatingVue from 'floating-vue';
import 'floating-vue/dist/style.css';
import HelpLink from './components/help/HelpLink.vue';

import { initMsal, msalInstance } from './services/msalInstance';
import axios from 'axios';
import { API_ENDPOINTS } from './services/config';

async function trySilentLogin() {
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0 && !store.state.loggedInUser) {
    const account = accounts[0];
    const entraUser = {
      entra_id: account.homeAccountId,
      username: account.username,
      name: account.name,
    };

    try {
      const response = await axios.post(API_ENDPOINTS.entraUser, entraUser);
      store.commit('setLoggedInUser', {
        id: response.data.id,
        name: response.data.name,
        username: response.data.username,
        entra_id: entraUser.entra_id,
      });
      console.log('Silent login succeeded');
    } catch (error) {
      console.error('Failed to restore user session from backend:', error);
    }
  }
}

await initMsal();
await trySilentLogin();

createApp(App)
  .use(store)
  .use(router)
  .use(Toast)
  .use(FloatingVue)
  .component('HelpLink', HelpLink)
  .mount('#app');

